import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';

import {
  REQUEST_ARTICLE_OG,
  FETCH_ARTICLE_OG_SUCCESS,
  FETCH_ARTICLE_OG_ERROR
} from 'actions/types';

async function fetchArticleOG(url) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `https://micro-open-graph-nzfnxwvluo.now.sh/?url=${url}`
    })
      .then(response => resolve(response))
      .catch(err => {
        reject(new Error(err));
      });
  });
}

export function* fetchOpenGraph(action) {
  if (!action) return;
  try {
    const data = yield call(fetchArticleOG, action.url);
    yield put({ type: FETCH_ARTICLE_OG_SUCCESS, data: data.data });
  } catch (err) {
    yield put({ type: FETCH_ARTICLE_OG_ERROR, err });
  }
}

export function* watchFetchArticleOG() {
  yield takeEvery(REQUEST_ARTICLE_OG, fetchOpenGraph);
}



// WEBPACK FOOTER //
// ./src/sagas/articles.js